import { api } from '@castlery/shared-redux-services';
import { EcEnv, WEB_CHANNEL, X_CHANNEL } from '@castlery/config';
import type { GlobalReviewResponse } from '../entity/reviews.entity';
import { get } from '@castlery/utils';
// import { get } from '@castlery/utils';

export const createReviewsByVariantApiPayload = ({
  variantCode,
  orderBy = 'recommended',
  country,
  pageNumber = 1,
  perPage = 15,
  bundleVariantCodes = '',
}: {
  variantCode: string;
  orderBy?: string;
  country?: string;
  pageNumber?: number;
  perPage?: number;
  bundleVariantCodes?: string;
}) => {
  return {
    url: '/gw/reviews/by_variant',
    params: {
      variant_code: variantCode,
      country: country || EcEnv.NEXT_PUBLIC_COUNTRY,
      order_by: orderBy,
      page: pageNumber,
      per_page: perPage,
      bundle_variant_codes: bundleVariantCodes,
    },
    headers: {
      [X_CHANNEL]: WEB_CHANNEL,
    },
  };
};

export const reviewsApi = api.injectEndpoints({
  endpoints: (builder) => {
    return {
      getReviewsByVariant: builder.query<
        GlobalReviewResponse,
        {
          variantCode: string;
          orderBy: string;
          pageNumber?: number;
          bundleVariantCodes?: string;
        }
      >({
        query: ({ variantCode, orderBy, pageNumber = 1, bundleVariantCodes = '' }) => {
          return {
            ...createReviewsByVariantApiPayload({
              variantCode,
              orderBy,
              pageNumber,
              bundleVariantCodes,
            }),
          };
        },
      }),
      getReviewSummary: builder.query<{ review_rating: number; review_count: number }, void>({
        query: () => 'product_reviews',
      }),
    };
  },
});

export const { useGetReviewsByVariantQuery, useGetReviewSummaryQuery } = reviewsApi;
export const { getReviewsByVariant, getReviewSummary } = reviewsApi.endpoints;

export const getReviewsByVariantServer = async ({
  variantCode,
  orderBy,
  pageNumber = 1,
}: {
  variantCode: string;
  orderBy: string;
  pageNumber?: number;
}) => {
  const { url, ...rest } = createReviewsByVariantApiPayload({
    variantCode,
    orderBy,
    pageNumber,
  });
  const queryStr = Object.keys(rest.params)
    .map((key) => `${key}=${rest.params[key]}`)
    .join('&');

  // const res = await fetch(`${EcEnv.NEXT_PUBLIC_API_HOST}${url}?${queryStr}`, {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     [X_CHANNEL]: WEB_CHANNEL,
  //   },
  // });
  // if (!res.ok) {
  //   throw new Error('Failed to fetch reviews');
  // }
  // const result = await res.json();
  // return result.results;
  try {
    const result = await get(
      `${EcEnv.NEXT_PUBLIC_API_HOST}${url}?${queryStr}`,
      {
        nextOption: {
          tags: [`web-reviews-${queryStr}`],
          revalidate: EcEnv.NEXT_PUBLIC_KNIGHT_API_REVALIDATE_TIME,
        },
      },
      undefined,
      1
    );
    return result.results;
  } catch (e) {
    throw new Error('Failed to fetch reviews');
  }
};
